export {default as RecentlyInactive} from './RecentlyInactive.connect';
